import {
  ConfirmItemKeywordType,
  ConfirmStatus,
  GamewearFilterKey,
} from 'types/marketplace/confirmItem';
import { FilterConfig, FilterValueType } from 'modules/utils/filterUtils';

/**
 * Gamewear Item 필터 정의
 */
export const GAMEWEAR_FILTERS: FilterConfig = {
  // 배열 타입 필터들
  statuses: {
    key: 'statuses',
    type: FilterValueType.NUMBER_ARRAY,
    defaultValue: [ConfirmStatus.PENDING, ConfirmStatus.PUBLISHED, ConfirmStatus.REJECTED],
  },
  salesTypes: {
    key: 'salesTypes',
    type: FilterValueType.NUMBER_ARRAY,
    defaultValue: [],
  },
  gameTypes: {
    key: GamewearFilterKey.GAME_TYPES,
    type: FilterValueType.STRING_ARRAY,
    defaultValue: [],
    apiKey: 'gametypes',
  },
  [GamewearFilterKey.INZOI_RECOLOR]: {
    key: GamewearFilterKey.INZOI_RECOLOR,
    type: FilterValueType.NUMBER_ARRAY,
    defaultValue: [],
  },
  [GamewearFilterKey.VRCHAT_AVATAR_COMPATIBILITY]: {
    key: GamewearFilterKey.VRCHAT_AVATAR_COMPATIBILITY,
    type: FilterValueType.STRING_ARRAY,
    defaultValue: [],
  },
  [GamewearFilterKey.VRCHAT_PLATFORM]: {
    key: GamewearFilterKey.VRCHAT_PLATFORM,
    type: FilterValueType.STRING_ARRAY,
    defaultValue: [],
  },
  [GamewearFilterKey.VRCHAT_ITEM_TYPE]: {
    key: GamewearFilterKey.VRCHAT_ITEM_TYPE,
    type: FilterValueType.STRING_ARRAY,
    defaultValue: [],
  },

  // 단일 값 필터들
  mdPick: {
    key: 'mdPick',
    type: FilterValueType.BOOLEAN,
    defaultValue: false,
  },
  curatorsPick: {
    key: 'curatorsPick',
    type: FilterValueType.BOOLEAN,
    defaultValue: false,
  },
  keyword: {
    key: 'keyword',
    type: FilterValueType.STRING,
    defaultValue: '',
    apiKey: 'searchKeyword',
  },
  keywordType: {
    key: 'keywordType',
    type: FilterValueType.NUMBER,
    defaultValue: ConfirmItemKeywordType.ItemName,
  },
};
